export default "__VITE_ASSET__IY_nu0ig__"